import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { RacingCardsSwiper, RaceSliderWrapper, RaceSwiperWrapper } from './NextRacesSlider.style';
import { RaceSliderItemLoader } from 'src/domains/sportsbook/webview/components/racesSlider/loader/RaceSliderItemLoader';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';

export const NextRacesSliderListLoader = observer('NextRacesSliderListLoader', () => {
    const common = useCommon();
    const {
        componentVariants: { sportsbookVariant },
    } = ConfigComponents.get(common).unifiedComponentConfig;
    return (
        <RaceSliderWrapper
            variant={sportsbookVariant}
            key='races-slider-races'
        >
            <RaceSwiperWrapper variant={sportsbookVariant}>
                <RacingCardsSwiper
                    key='slider-swiper'
                    inProgress={true}
                >
                    {Array.from({ length: 12 }, (_, x) => (
                        <RaceSliderItemLoader key={`placeholder-racing-card-${x}`} />
                    ))}
                </RacingCardsSwiper>
            </RaceSwiperWrapper>
        </RaceSliderWrapper>
    );
});
